import {styled} from "@mui/material/styles";
import {Card, FormControl, Grid} from "@mui/material";

export const SupplierBookingContainer = styled(Grid)<{ noBookings?: boolean }>(({noBookings}) => ({
  ...(noBookings && {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh'
  })
}));

export const SupplierBookingShowMessage = styled(Grid)(() => ({
  '& img': {
    width: "25em",
    height: '100%',
    '@media (max-width:39.28em)': {
      width: '100%',
    }
  }
}));

export const SupplierBookingDisableModalContent = styled(FormControl)(() => ({
  margin: '1em'
}));

export const SupplierBookingDisableModalButtons = styled(Card)(() => ({
  display: 'flex',
  justifyContent: 'flex-end'
}));
